module.exports = __webpack_public_path__ + "media/images/placeholders/person-0c297eba8ba1b755dfe434bb50c31bed.svg";